import React from "react";
import { Controls, IFormStyles, useFormStyles } from "../.";

export const FormHidden: React.FC<Controls.ControlHiddenProps> = (props) => {
    const styles: IFormStyles = useFormStyles();

    return (
        <Controls.ControlHidden {...props} controlStyles={styles.control} />
    );
};